module.exports = __webpack_public_path__ + "img/mubang-1.bfe5b678.png";